const completePartialJson = (str) => {
  let result = (str || '').trim();
  const openBraces = (result.match(/{/g) || []).length;
  const closeBraces = (result.match(/}/g) || []).length;
  const quoteCount = (result.match(/"/g) || []).length;

  if (quoteCount % 2 !== 0) {
    result += '"';
  }
  for (let i = 0; i < openBraces - closeBraces; i += 1) {
    result += '}';
  }
  return result;
};

// LLMs sometimes return structured objects nested under `answer` / `reasoning`
// (e.g. { timeline: [...], summary: "..." }). React can't render objects, so
// coerce anything non-string to a JSON string for display. `null` / `undefined`
// stay null so callers can short-circuit the empty case.
const coerceToDisplayString = (value) => {
  if (value == null) return null;
  if (typeof value === 'string') return value;
  try {
    return JSON.stringify(value, null, 2);
  } catch (_) {
    return String(value);
  }
};

export const parseReasoningResult = (jsonString) => {
  try {
    const json = JSON.parse(jsonString);
    return {
      answer: coerceToDisplayString(json.answer),
      reasoning: coerceToDisplayString(json.reasoning),
    };
  } catch (_) {
    try {
      const json = JSON.parse(completePartialJson(jsonString));
      return {
        answer: coerceToDisplayString(json.answer),
        reasoning: coerceToDisplayString(json.reasoning),
      };
    } catch (_) {
      return null;
    }
  }
};
